import React from "react";
import { useSelector, useDispatch } from "react-redux";

import {
  Container,
  AppBar,
  makeStyles,
  Theme,
  createStyles,
  Toolbar,
  Typography,
  Paper,
  Grid,
  TextField,
  MenuItem,
} from "@material-ui/core";
import Persistence from "./persistence";
import { authStatusSelector } from "../common/redux/selectors";
import { localLoginStart } from "./redux/actions";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      flexGrow: 1,
    },
    title: {
      flexGrow: 1,
    },
    content: {
      marginTop: 10,
      padding: 50,
    },
    logout: {
      position: "fixed",
      top: 0,
      right: 0,
      zIndex: 999999,
      color: theme.palette.secondary.main,
    },
  })
);

export const Component: React.FC = (props) => {
  const authStatus = useSelector(authStatusSelector);
  const dispatch = useDispatch();

  const currentUser = Persistence.getCurrentUser();

  switch (authStatus) {
    case "LOGGING_IN":
      // we could show some content here if appropriate
      return <React.Fragment />;
    case "NOT_LOGGED_IN":
      if (currentUser?.upn) {
        // if there is a user in local storage then we're logged in
        dispatch(localLoginStart(currentUser));
        return null;
      } else {
        return <NotLoggedInContent />;
      }
    case "LOGGED_IN":
      return <React.Fragment>{props.children}</React.Fragment>;

    default:
      throw new Error(`Unknown authStatus ${authStatus} in localAuthorization`);
  }
};

const NotLoggedInContent: React.FC = () => {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <Container maxWidth="md">
        <AppBar position="static">
          <Toolbar>
            <Typography variant="h6" className={classes.title}>
              Development Login
            </Typography>
          </Toolbar>
        </AppBar>

        <Paper className={classes.content}>
          <Grid container>
            <Grid item sm={2} style={{ paddingTop: "5px" }}>
              Log in as user:
            </Grid>
            <Grid item sm={10}>
              <TextField
                select
                name="user"
                fullWidth
                onChange={(e) => {
                  Persistence.setCurrentUser(e.target.value);
                }}
              >
                {Persistence.getUsers().map((user) => (
                  <MenuItem value={user.upn} key={user.upn}>
                    {user.displayName}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>
          </Grid>
        </Paper>
      </Container>
    </div>
  );
};
